import * as actions from '../constants/departmentConstants';

const initialState = {
    departments:[]
};

export const departmentReducers = (state = initialState, action) => {
	switch (action.type) {
        case actions.FETCH_DEPARTMENT_REQUEST:
			return {
				...state,
				loading: true,
			};
		case actions.FETCH_DEPARTMENT_SUCCESS:
			return {
				...state,
				loading: false,
				departments: action.payload,
			};
		case actions.FETCH_DEPARTMENT_FAILED:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};